<script>
import { ref } from "vue";
const value = ref();
const currentDate = ref(new Date());
const currentDateOne = ref(new Date());
export default {
  data() {
    return {
      isPasswordVisible: false,
      JeffSelc: ["Select", "Jeff Fitch", "Donald Gordon"],
      ComputerSelc: ["Select", "Computer Services", "Car Repair Services"],
      FitchSel: ["Select", "Jeff Fitch", "Donald Gordon"],
      startdate: currentDate,
      startdateOne: currentDateOne,
      dateFormat: "dd-MM-yyyy",
    };
  },
  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
    submitFormOne() {
      this.$router.push("/provider/provider-booking");
    },
    submitForm() {
      this.$router.push("/customer/user-bookings");
    },
  },
};
</script>
<template>
  <!-- Delete Account -->
  <div class="modal fade custom-modal" id="del-account">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Delete Account</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form action="#">
          <div class="modal-body">
            <p class="mb-3">
              Are you sure you want to delete This Account? To delete your account, Type
              your password.
            </p>
            <div class="mb-0">
              <label class="form-label">Password</label>
              <div class="pass-group">
                <input
                  :type="isPasswordVisible ? 'text' : 'password'"
                  class="form-control pass-input"
                  placeholder="*************"
                />
                <span
                  @click="togglePasswordVisibility"
                  :class="
                    isPasswordVisible
                      ? 'toggle-password feather-eye'
                      : 'toggle-password feather-eye-off'
                  "
                ></span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <button type="submit" class="btn btn-dark" data-bs-dismiss="modal">
              Delete Account
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Delete Account -->

  <!-- Add Booking -->
  <div class="modal fade custom-modal" id="add_booking">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Add Booking</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form @submit.prevent="submitFormOne">
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Staff</label>
                  <vue-select :options="JeffSelc" id="jeffselc" placeholder="Select" />
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Service</label>
                  <vue-select
                    :options="ComputerSelc"
                    id="computerselc"
                    placeholder="Select"
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Customer</label>
                  <vue-select :options="FitchSel" id="fitchsel" placeholder="Select" />
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <div class="sel-cal Calendar-icon">
                    <span><i class="ti ti-calendar-month"></i></span>
                    <date-picker
                      v-model="startdate"
                      placeholder=""
                      class="datetimepicker form-control"
                      :editable="true"
                      :clearable="false"
                      :input-format="dateFormat"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="mb-3">
                      <div class="sel-cal Calendar-icon">
                        <span><i class="ti ti-clock"></i></span>
                        <date-picker
                          v-model="startdateOne"
                          placeholder=""
                          class="datetimepicker form-control"
                          :editable="true"
                          :clearable="false"
                          :input-format="dateFormat"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="mb-3">
                      <div class="sel-cal Calendar-icon">
                        <span><i class="ti ti-clock"></i></span>
                        <a-time-picker
                          class="form-control timepicker"
                          placeholder="Choose"
                          use12-hours
                          format="h:mm a"
                          type="text"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-0">
                  <label class="form-label">Booking Message</label>
                  <textarea rows="4" class="form-control"></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <button type="submit" class="btn btn-dark">Submit</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Add Booking -->

  <!-- Reschedule Appointment -->
  <div class="modal fade custom-modal" id="reschedule">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Reschedule Appointment</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <div class="modal-body">
          <form @submit.prevent="submitForm">
            <div class="mb-3">
              <label class="form-label">Appointment Date</label>
              <div class="form-icon">
                <date-picker
                  v-model="startdate"
                  placeholder=""
                  class="datetimepicker form-control"
                  :editable="true"
                  :clearable="false"
                  :input-format="dateFormat"
                />
                <span class="cus-icon"><i class="feather-calendar"></i></span>
              </div>
            </div>
            <div class="mb-0">
              <label class="form-label">Appointment Time</label>
              <div class="form-icon">
                <a-time-picker
                  class="form-control timepicker"
                  placeholder="Choose"
                  use12-hours
                  format="h:mm a"
                  type="text"
                />
                <!-- <span class="cus-icon"><i class="feather-clock"></i></span> -->
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <div class="acc-submit">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <button class="btn btn-dark" type="submit">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Reschedule Appointment -->

  <!-- Cancel Appointment -->
  <div class="modal fade custom-modal" id="cancel_appointment">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Cancel Appointment</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <p>
              Are you sure you want to cancel
              <span class="text-dark"> John Doe</span> appointment on
              <span class="text-dark"> Oct 28, 2022</span> at time
              <span class="text-dark"> 10AM - 12PM</span>
            </p>
          </div>
          <div class="modal-footer">
            <div class="acc-submit">
              <a
                href="javascript:void(0);"
                class="btn btn-light me-2"
                data-bs-dismiss="modal"
                >Dismiss</a
              >
              <button class="btn btn-dark" type="submit">Yes, Cancel</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Cancel Appointment -->

  <!-- Add Review -->
  <div class="modal fade custom-modal" id="add-review">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Write A Review</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <div class="write-review">
              <div class="review-add d-flex align-items-center mb-3">
                <div class="rev-img me-2">
                  <img src="@/assets/img/services/service-19.jpg" alt="image" />
                </div>
                <div>
                  <h6 class="fs-16 fw-medium mb-1">Computer Services</h6>
                  <p class="fs-12">Newyork, USA</p>
                </div>
              </div>
              <div
                class="form-info d-flex align-items-center justify-content-between mb-3"
              >
                <p class="fw-medium text-dark mb-0">Rate The Service</p>
                <div class="rating-select mb-0">
                  <a href="javascript:void(0);"><i class="fas fa-star"></i></a>
                  <a href="javascript:void(0);"><i class="fas fa-star"></i></a>
                  <a href="javascript:void(0);"><i class="fas fa-star"></i></a>
                  <a href="javascript:void(0);"><i class="fas fa-star"></i></a>
                  <a href="javascript:void(0);"><i class="fas fa-star"></i></a>
                </div>
              </div>
              <div class="mb-0">
                <label class="col-form-label">Write your Review</label>
                <textarea
                  class="form-control"
                  rows="4"
                  placeholder="Please write your review"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <button type="submit" class="btn btn-dark">Send</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Add Review -->
</template>
